export const create = {
  form: {
    name: '水洗機表記名',
    typeName: '水洗機種類',
    washingInfo: '水洗機情報',
    tankInfo: '使用洗剤タンク',
    tankNo: '洗剤 No.',
    submit: '新規追加',
    select: '選択',
    requireName: '水洗機表記名を入力してください',
    requireTypeName: '水洗機種類を入力してください',
  },
  pageHeader: {
    title: '水洗機リスト　新規追加画面',
    back: '戻る',
  },
}
